import {useMutation} from 'react-query'

import {mutations} from '../../mutations'
import {hubQueryClient} from '../../QueryProvider'

export const usePersistRmcContact = () => {
  return useMutation(mutations.persistRmcContact, {
    onMutate: async ({siteNumber}) => {
      await hubQueryClient.invalidateQueries(['persistedRmcContact', siteNumber])
    },
    onSuccess: (data, {siteNumber}) => {
      hubQueryClient.setQueryData(['persistedRmcContact', siteNumber], data)
    }
  })
}
